import MojitoCore from 'mojito/core';
import BonusHistoryControllerImpl from './bonus-history-controller.js';
import PropTypes from 'prop-types';

/**
 * Component responsible for bonus history data presentation.
 *
 * @name Controller
 * @class BonusHistoryController
 * @memberof Mojito.Modules.BonusHistory
 */

/**
 * BonusHistoryController prop types.
 *
 * @property {boolean} [showPrewager = true] - Indicate that prewager should be displayed.
 *
 * @memberof Mojito.Modules.BonusHistory.Controller
 */
const propTypes = {
    showPrewager: PropTypes.bool,
};

const defaultProps = {
    showPrewager: true,
};

export default MojitoCore.Presentation.UIControllerView(
    'BonusHistoryController',
    BonusHistoryControllerImpl,
    propTypes,
    defaultProps
);
